import {
  Modal,
  ModalLayout,
  ModalCloseButton,
  ModalPrevButton,
  ModalContent,
  ModalTitle,
  SliderLayout,
  PreviewCloseButton,
  PreviewLabel,
} from './index.styled';
import { useRef, memo } from 'react';
import useOnClickOutside from '../../utils/hooks/use-on-click-outside';
import LeftCorner from '../../assets/images/leftCorner.svg';
import Cross from '../../assets/images/Union.svg';

const CustomModalLayout = ({
  handleModalClose,
  title,
  children,
  isModalOpen,
  width,
  contentPadding,
  height,
  fixedHeight,
  isEvents,
  withoutCloseBtn,
  showPrevBtn,
  handlePrevBtn,
  withClosePreview,
  withLabel,
  labelText,
  zIndex,
  fullOverlay,
  cannotClose,
}) => {
  const ref = useRef();
  useOnClickOutside(ref, cannotClose ? () => {} : handleModalClose);
  return (
    <ModalLayout fullOverlay={fullOverlay} active={isModalOpen} isEvents={isEvents} zIndex={zIndex}>
      <Modal ref={ref} width={width} height={height} isEvents={isEvents}>
        {withLabel && <PreviewLabel>{labelText}</PreviewLabel>}
        {showPrevBtn && (
          <ModalPrevButton onClick={handlePrevBtn}>
            <LeftCorner />
          </ModalPrevButton>
        )}
        {!withoutCloseBtn && (
          <ModalCloseButton onClick={cannotClose ? () => {} : handleModalClose}>
            &times;
          </ModalCloseButton>
        )}
        {withClosePreview && (
          <PreviewCloseButton onClick={cannotClose ? () => {} : handleModalClose}>
            Close Preview <Cross />
          </PreviewCloseButton>
        )}

        {title && <ModalTitle>{title}</ModalTitle>}
        <ModalContent
          fullOverlay={fullOverlay}
          fixedHeight={fixedHeight}
          content_padding={contentPadding}
          isEvents={isEvents}
        >
          {children}
        </ModalContent>
      </Modal>
    </ModalLayout>
  );
};
export default memo(CustomModalLayout);
